module.exports = __webpack_public_path__ + "static/img/home-four-1.a4bb47f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home-four-1.png
// module id = HQrq
// module chunks = 1